<div class="card h--100" [ngClass]="{ 'pink-bg': pinkBg }">
  <div class="fs-18 mb-1 d--f ai--c">
    <img
      *ngIf="resource.type === 'rep_company' && resource.logo"
      [src]="resource.logo"
      class="card-logo mr-1"
      alt=""
    />
    <span>{{ resource.name | titlecase }}</span>
  </div>
  <hr />
  <div class="d--f fd--c p-0">
    <ng-container *ngIf="resource.type === 'hospital'">
      <div class="d--f jc--sb mt-1">
        <div class="f-300">City</div>
        <div class="fs-16">{{ resource.city || "-" }}</div>
      </div>
      <div class="d--f jc--sb mt-1">
        <div class="f-300">Contact</div>
        <div class="fs-16">{{ resource.contactNumber || "-" }}</div>
      </div>
      <div class="d--f jc--sb mt-1">
        <div class="f-300 mr-2">Address</div>
        <div class="fs-16 text-right">{{ resource.address || "-" }}</div>
      </div>
    </ng-container>

    <div class="d--f jc--fe ai--c mt-2">
      <mat-icon color="primary" class="pointer mr-2" (click)="onEdit($event)">edit</mat-icon>
      <mat-icon color="primary" class="pointer" (click)="onDelete($event)">delete</mat-icon>
    </div>
  </div>
</div>
